<template>
  <div v-if="!empty">
    <div class="page-header m-t-0 m-b-sm">
      <h1 class="m-n text-u-c">Articles</h1>
      <div class="viewAll" v-if="views" @click="viewAll()">view all</div>
    </div>
    <div>
      <div v-for="(article, index) of articles" :key="index" class="art-content">
        <a>
          <div class="img-block">
            <div @click="goDetails(article.id)" class="img-container">
              <lazy-img-loader
                :mainImg="getArticleImage(article)"
                :fallbackImg="'/vue-app/assets/img/article.svg'"
                :imgAlt="article.title"
                :imgClass="'article-image'"
              ></lazy-img-loader> 
            </div>
          </div>
          <div class="art-title">{{article.title}}</div>
          <div class="art-block">
            <span v-on:click="goDetails(article.id)" class="art-ago">{{getAgo(article.modified)}}</span>
            <span
              v-if="article.owner"
              @click="goOwner(article.owner.id)"
              class="art-owner"
            >{{article.owner.name}}</span>
          </div>
        </a>
      </div>
      <div v-if="loader">
        <pre-loader></pre-loader>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment-timezone'
import shave from 'shave'
import ApiService from '@src/services/ApiService'
import LazyImgLoader from '@src/components/lazy-img-loader'

export default {
  components: {LazyImgLoader},
  data() {
    return {
      loader: false,
      apiService: new ApiService(),
      isOwner: false,
      views: false,
      empty: false,
      articles: null,
      perPage: 3,
      page: 1,
    }
  },
  created() {
    this.getArticles(this.profile.profile_id)
    moment.updateLocale('en', {
      relativeTime: {
        future: 'in %s',
        past: '%s ago',
        s: '%ds',
        m: '1m',
        mm: '%dm',
        h: '1h',
        hh: '%dh',
        d: '1d',
        dd: '%dd',
        M: '1 month',
        MM: '%d months',
        y: '1 year',
        yy: '%d years',
      },
    })
  },
  computed: {
    profile() {
      return this.$store.getters.profile
    },
  },
  methods: {
    getArticles(profile_id = null) {
      this.loader = true
      if (profile_id) {
        this.apiService
          .get(
            `/article?community_id=${window.user.community_id}&profile_id=${profile_id}&page=${this.page}&per-page=${this.perPage}&expand=owner`
          )
          .then((res) => {
            this.empty = res._meta.totalCount === 0
            if (this.empty) this.getArticles()
            this.articles = res.items
            this.views = res._meta.pageCount > res._meta.currentPage
            this.loader = false
            setTimeout(() => {
              shave('.art-title', 40, { character: '...' })
            }, 200)
          })
      } else {
        this.apiService
          .get(
            `/article?community_id=${window.user.community_id}&page=${this.page}&per-page=${this.perPage}&expand=owner`
          )
          .then((res) => {
            this.empty = res._meta.totalCount === 0
            this.articles = res.items
            this.views = res._meta.pageCount > res._meta.currentPage
            this.loader = false
            setTimeout(() => {
              shave('.art-title', 40, { character: '...' })
            }, 200)
          })
      }
    },
    onScroll() {
      this.page++
      this.getArticles(true)
    },
    addAWS(url) {
      if (!/^(f|ht)tps?:\/\//i.test(url)) {
        url = process.env.AWS_URL + '/' + url
      }
      return url
    },
    getArticleImage(article){
      const thumb = article.thumbs
        ? (article.thumbs['thumb'] 
          ? article.thumbs['thumb'] 
          : article.thumbs['thumb-lg']
        )
        : null;
       return thumb
        ? thumb 
        : '/vue-app/assets/img/article.svgs'
    },
    getAgo(time) {
      return moment.unix(time).fromNow()
    },
    goOwner(id) {
      this.$router.push(`../${id}`)
    },
    goDetails(id) {
      window.location.assign(
        `${window.user.community_url}/${window.user.community_domain}/post/view/${id}`
      )
    },
    goContainer(id, type) {
      switch (type) {
        case 'profile':
          window.location.assign(
            `${window.user.community_url}/${window.user.community_domain}/profiles/view/${id}`
          )
          break
        case 'groups':
          window.location.assign(
            `${window.user.community_url}/${window.user.community_domain}/groups/view/${id}`
          )
          break
        case 'blog':
          window.location.assign(
            `${window.user.community_url}/${window.user.community_domain}/blog/view/${id}`
          )
          break
      }
    },
    viewAll() {
      this.$router.push('articles')
    },
  },
}
</script>

<style type="scss" scoped>
.lazy-image-placeholder {
  background-position: center center;
  background-repeat: no-repeat;
  background-size: auto;
}
.lazy-img,
.lazy-image-main {
  width: 100%;
}
.loader {
  width: 200px;
  height: 100px;
  left: calc(50% - 100px);
}
.page-header {
  margin-top: 17px;
  margin-bottom: 0;
  color: #000;
}
.page-header h1 {
  font-style: normal;
  font-weight: 300 !important;
  font-size: 20px;
  line-height: 23px;
  letter-spacing: 0.72px;
}
.left-side {
  margin-top: 0 !important;
  margin-bottom: 50px !important;
}
.art-title {
  font-weight: 500;
  font-size: 13px;
  line-height: 15px;
  margin-top: 10px;
  color: #000000;
}
.art-ago {
  font-weight: normal;
  font-size: 11px;
  line-height: 13px;
  color: #888888;
}
.art-owner {
  font-weight: normal;
  font-size: 11px;
  line-height: 13px;
  color: #000000;
}
.art-block {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 100%;
  display: block;
  border-bottom: 1px solid #d9d9d9;
  padding-bottom: 10px;
  margin-bottom: 15px;
}
.img-block {
  width: 100%;
  height: 112px;
  display: flex;
  align-items: center;
  overflow: hidden;
}
.img-block .img-container {
  height: 100%;
  width: 100%;
  cursor: pointer;
  background-color: white;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
}
</style>

<style type="scss">
.article-image{
  width: 100% !important;
  height: 100% !important;
}
</style>